import useStore from './useStore';

const useSubscriptionStore = () => {
    const { subscriptionStore } = useStore();

    return subscriptionStore;
};

export default useSubscriptionStore;
